export const MODULE_ACCESS = {
  manage_videos: {
    label: 'Manage Videos',
    rows: [
      {
        label: 'Video Library',
        value: 'video_library',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Series Library',
        value: 'series_library',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Manage Descriptions',
        value: 'manage_descriptions',
        access: ['view', 'manage'],
      },
      {
        label: 'License Management',
        value: 'license_management',
        access: ['view', 'manage'],
      },
    ],
  },
  organize_videos: {
    label: 'Organize Videos',
    rows: [
      {
        label: 'Genres',
        value: 'genres',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Playlists',
        value: 'playlists',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Collections',
        value: 'collections',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
    ],
  },
  schedule_videos: {
    label: 'Schedule Videos',
    rows: [
      {
        label: 'Rule-Based Scheduling',
        value: 'rule_based_scheduling',
        access: ['view', 'manage'],
      },
      {
        label: 'Preview Channels',
        value: 'preview_channels',
        access: ['view'],
      },
      {
        label: 'Rules Library',
        value: 'rules_library',
        access: ['view', 'create', 'edit', 'delete'],
      },
      {
        label: 'Manual Assignment',
        value: 'manual_assignment',
        access: ['view', 'manage'],
      },
    ],
  },
  manage_channels: {
    label: 'Manage Channels',
    rows: [
      {
        label: 'Channel Settings',
        value: 'channel_settings',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Global Assets',
        value: 'global_assets',
        access: ['view', 'create', 'edit', 'delete'],
      },
      {
        label: 'Channel Packager',
        value: 'channel_packager',
        access: ['view', 'create', 'delete', 'manage'],
      },
    ],
  },
  manage_users: {
    label: 'Manage Users',
    rows: [
      {
        label: 'All Users',
        value: 'all_users',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'All Subscribers',
        value: 'all_subscribers',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Promo Codes',
        value: 'promo_codes',
        access: ['view', 'create', 'edit', 'delete'],
      },
      {
        label: 'Promo Code Categories',
        value: 'promo_code_categories',
        access: ['view', 'create', 'edit', 'delete'],
      },
    ],
  },
  manage_distributors: {
    label: 'Manage Distributors',
    rows: [
      {
        label: 'Distributors',
        value: 'distributors',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
    ],
  },
  advertising: {
    label: 'Advertising',
    rows: [
      {
        label: 'Advertising',
        value: 'advertising',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
    ],
  },
  data_management: {
    label: 'Data Management',
    rows: [
      { label: 'Import', value: 'import', access: ['view'] },
      { label: 'Export', value: 'export', access: ['view'] },
    ],
  },
  analytics: {
    label: 'Analytics',
    rows: [{ label: 'Analytics', value: 'analytics', access: ['view'] }],
  },
  settings: {
    label: 'Settings',
    rows: [
      {
        label: 'Workspaces',
        value: 'workspaces',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Mail Server',
        value: 'mail_server',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Email Templates',
        value: 'email_templates',
        access: ['view', 'create', 'edit', 'delete'],
      },
      {
        label: 'Channel Genres',
        value: 'channel_genres',
        access: ['view', 'create', 'edit', 'delete', 'manage'],
      },
      {
        label: 'Blacklist Sources',
        value: 'blacklist_sources',
        access: ['view', 'create', 'delete'],
      },
      {
        label: 'System Health',
        value: 'system_health',
        access: ['view', 'manage'],
      },
    ],
  },
};

export const MODULE_ACCESS_OPERATIONS = {
  view: 'View',
  create: 'Create',
  edit: 'Edit',
  delete: 'Delete',
  manage: 'Manage',
};
